// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9ee5a327","239":"e0002f01","453":"9388b559","455":"0d989ac7"}[chunkId] + ".chunk.js";
};